export const enforceTermsOnForm = formElement => {
  if (!formElement) {
    return;
  }

  const termsInput: any = formElement.querySelector("#terms,.terms");

  const errorElement = document.createElement("span");

  if (formElement && termsInput) {
    errorElement.classList.add("field-validation-error");
    errorElement.textContent = "You must agree to the Privacy Collection Statement";
    termsInput.parentNode.appendChild(errorElement);

    termsInput.addEventListener("change", (event: any) => {
      if (event.target.checked) {
        errorElement.style.display = "none";
      } else {
        errorElement.style.display = "block";
      }
    });

    formElement.addEventListener("submit", (event: any) => {
      if (!termsInput.checked) {
        event.preventDefault();
        errorElement.style.display = "block";
      }
    });
  }
};
